import left from './assets/landscape/foreground-left.svg';
import right from './assets/landscape/foreground-right.svg';
import './gameCard.css';
export const gameCard = {
  left: `${left}#svgView(viewBox(0,296,480,504))`,
  right: `${right}#svgView(viewBox(1232,376,440,424))`,
};
